import { v1 } from './v1';

export const systemEvents = {
  v1,
};
